import axios from 'axios';

export const CompanyExpendInUSDService = {
    getExpendByMonth: (date) => {
        const url = `${process.env.REACT_APP_API_ADMIN_URL}/company-expend-in-usd/${date}`;
        return axios.get(url);
    },
};
